import Constantes from './Constantes';
import PdfStyles from './PdfStyles';

const CoreCommon = {
  Constantes,
  PdfStyles
};

export default CoreCommon;
